var _title, _path, _path2, _path3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgParagraph(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 40 40"
  }, props), _title || (_title = /*#__PURE__*/React.createElement("title", null, "paragraph")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.35,12H3.65a2,2,0,0,1,0-4h32.7a2,2,0,0,1,0,4Z",
    fill: "#231f20"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M36.35,22.43H3.65a2,2,0,1,1,0-4h32.7a2,2,0,0,1,0,4Z",
    fill: "#231f20"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20,32.85H3.65a2,2,0,1,1,0-4H20a2,2,0,0,1,0,4Z",
    fill: "#231f20"
  })));
}

export default SvgParagraph;